import React, { useState, useEffect } from "react";
import "./fundledger.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaCopy } from "react-icons/fa";
import Loader from "../Loader";
import Userdashboardheader from "../userdashboardheader/Userdashboardheader";
const Fundledger = ({ route }) => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("");
  const [proofImage, setProofImage] = useState("");
  const [proofImageFile, setProofImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [transactionId, setTransactionId] = useState(null);
  const [cryptoAssets, setCryptoAssets] = useState([]);
  const [copySuccess, setCopySuccess] = useState(false);

  useEffect(() => {
    const fetchCryptoAssets = async () => {
      try {
        const response = await axios.get(
          `${route}/crypto-assets/public/active`
        );
        if (response.data.status === "ok") {
          setCryptoAssets(response.data.assets);
          if (response.data.assets.length > 0) {
            setMethod(response.data.assets[0].symbol);
          }
        }
      } catch (error) {
        console.error("Error fetching crypto assets:", error);
        setError("Failed to load payment methods");
      }
    };

    fetchCryptoAssets();
  }, [route]);

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'upload');
    
    try {
      const response = await fetch('https://api.cloudinary.com/v1_1/duesyx3zu/image/upload', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      return data.secure_url;
    } catch (error) {
      console.error('Error uploading to Cloudinary:', error);
      throw new Error('Failed to upload proof image');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!proofImageFile) {
      setError("Please upload proof of payment before submitting");
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      // Step 1: Create the fund request
      const fundResponse = await axios.post(
        `${route}/ledger/fund`,
        { 
          amount: parseFloat(amount), 
          method
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      );

      const transactionId = fundResponse.data.fundRequest._id;
      setTransactionId(transactionId);

      // Step 2: Upload to Cloudinary
      const cloudinaryUrl = await uploadToCloudinary(proofImageFile);

      // Step 3: Submit the proof
      await axios.post(
        `${route}/ledger/proof`,
        {
          transactionId: transactionId,
          proofImage: cloudinaryUrl
        },
        {
          headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
          },
        }
      );

      setSuccess("Funding request and proof submitted successfully!");
    } catch (error) {
      setError(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProofImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setProofImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const getSelectedCryptoAsset = () => {
    return cryptoAssets.find((asset) => asset.symbol === method);
  };

  const handleCopyAddress = async () => {
    const address = getSelectedCryptoAsset()?.walletAddress;
    if (address) {
      try {
        await navigator.clipboard.writeText(address);
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      } catch (err) {
        console.error('Failed to copy address:', err);
      }
    }
  };

  return (
    <div>
      {loading && <Loader />}

      <Userdashboardheader route={route} />
      <div className="fund-ledger-container">
        <div className="fund-ledger-card">
          <h2>Fund Your Ledger</h2>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Amount (USD)</label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter amount"
                required
                min="10"
              />
            </div>

            <div className="form-group">
              <label>Payment Method</label>
              <select
                value={method}
                onChange={(e) => setMethod(e.target.value)}
                required
              >
                <option value="">Select payment method</option>
                {cryptoAssets.map((asset) => (
                  <option key={asset.symbol} value={asset.symbol}>
                    {asset.name} ({asset.symbol})
                  </option>
                ))}
              </select>
            </div>

            {method && (
              <div className="payment-details">
                <h3>Payment Details</h3>
                <p>Send payment to this address:</p>
                <div className="address-box">
                  <span>{getSelectedCryptoAsset()?.walletAddress}</span>
                  <button 
                    type="button" 
                    className="copy-button" 
                    onClick={handleCopyAddress}
                    title="Copy address"
                  >
                    <FaCopy />
                    {copySuccess && <span className="copy-tooltip">Copied!</span>}
                  </button>
                </div>
                <p className="note">
                  Please copy the address carefully and send the exact amount.
                  After sending, upload your payment proof below.
                </p>
              </div>
            )}

            <div className="form-group">
              <label>Upload Payment Proof</label>
              <input
                type="file"
                onChange={handleImageUpload}
                accept="image/*"
                required
              />
            </div>

            {proofImage && (
              <div className="proof-preview">
                <img src={proofImage} alt="Payment proof" />
              </div>
            )}

            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            <button type="submit" className="submit-btn" disabled={!method || !proofImage}>
              Submit Payment
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Fundledger;
